// extracted by mini-css-extract-plugin
export default {"input":"style_input__oW2Oq","button":"style_button__pd8n3"};